export const stores = {
    "snackbar": {
      "create": {
        "success": "La unidad se creó exitosamente",
        "error": "Ocurrió un error al crear la unidad"
      },
      "update": {
        "success": "La unidad se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar la unidad"
      },
      "associateDivision": {
        "error": "Ocurrió un error al asociar las divisiones"
      },
      "associateZone": {
        "error": "Ocurrió un error al asociar las zonas"
      },
      "associateDivisionAndZone": {
        "error": "Ocurrió un error al asociar las zonas y las divisiones"
      }
    },
    "modalTypeAgent": {
      "assignedUsers": "Usuarios asignados",
      "associateAgent": "Usuarios asociados",
      "searchAgent": "Buscar usuarios"
    },
    "filter": {
      "title": "Unidades",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar unidad",
        "firstSelect": "Estatus de la unidad",
        "rol": "Rol"
      }
    },
    "informationCard": {
      "checkUser": "Ver usuarios asociados",
      "create": {
        "title": "Nueva unidad"
      },
      "edit": {
        "title": "Editar unidad"
      },
      "buttons": {
        "add": "Agregar unidad",
        "cancel": "Cancelar",
        "edit": "Actualizar unidad"
      }
    },
    "modal": {
      "delete": {
        "title": "¿Está seguro que desea eliminar una unidad?",
        "description": "Al eliminar una unidad, se borrará de tu lista y debes realizar nuevamente su registro",
        "success": {
          "title": "La unidad se eliminó exitosamente",
          "description": ""
        },
        "error": {
          "title": "Hay un error y la unidad no puede ser eliminada",
          "description": ""
        }
      }
    },
    status: {
      active: 'Activa',
      inactive: 'Inactiva',
      remodelation: 'Remodelación',
      opening: 'Apertura',
      closed: 'Cerrado',
      inventory: 'Inventario',
      audit: 'Auditoría'
    }
  }